<div class="projects__trigger" (click)="projectsTrigger()" [ngClass]="active ? 'active' : ''">Project: <p>{{ projController.activeProject.name }}</p></div>
<div class="projects">
    <div class="projects__container" [ngClass]="active ? 'active' : ''">
        <div class="row">
            <div class="row__item">
                <div>
                    <label>Project Explorer </label>
                    <div *ngFor="let project of this.projectController.projects">
                        <p *ngIf="project.active;else other_content" [ngClass]="project.selected? 'selected' : ''" (click)="projController.selectProject(project)">
                            {{ project.name }}
                            <span class="active">ACTIVE</span>
                        </p>
                        <ng-template #other_content>
                          <p [ngClass]="project.selected? 'selected' : ''" (click)="projController.selectProject(project)">
                              {{ project.name }}
                              <span (click)="activateProject(project)">ACTIVE</span>
                            </p>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="row__item">
                <div title="Share Project" class="shareProj" [ngClass]="this.projectController.selectedProject ? 'active' : ''"></div>
            </div>
            <div class="row__item">
                <div title="Project Details" class="projDetail" [ngClass]="this.projectController.selectedProject != undefined && this.projectController.selectedProject.id == this.projectController.activeProject.id && this.projectController.activeProject.editable ? 'active' : ''" (click)="editProjectDetailsTrigger()"></div>
            </div>
            <div class="row__item">
                <div title="New Project" class="newProj" (click)="addProjectTrigger()"></div>
            </div>
            <div class="row__item">
                <div title="Edit Project" class="editProj"  [ngClass]="this.projectController.selectedProject != undefined && this.projectController.selectedProject.editable ? 'active' : ''" (click)="editProjectTrigger()"></div>
            </div>
            <div class="row__item">
                <div title="Delete Project" class="deleteProj" [ngClass]="this.projectController.selectedProject != undefined && this.projController.selectedProject.name != 'Default' ? 'active' : ''" (click)="deleteProjectTrigger()"></div>
            </div>
        </div>
    </div>
</div>
